import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import HomeIcon from "@mui/icons-material/Home";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { Button, Menu, MenuItem, Stack, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import argocdlIcon from "./images/ArgoCD.png";

const AppMenuBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const IsAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      setAnchorEl(null);
      // Assuming 'instance' is your MSAL instance
      await instance.logout();
    } catch (error) {
      // Handle logout error
      console.error("Logout error:", error);
    } finally {
      navigate("/")
    }
  };
  // const handleLogout = () => {
  //   const account = instance.getActiveAccount();
  //   if (account) {
  //     instance.logoutRedirect({});
  //   }
  //   setAnchorEl(null);
  // };
  const handleUserInfo = () => {
    navigate("/user-info");
    setAnchorEl(null);
  };

  return (
    <div style={{ minHeight: "8vh" }}>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed">
          <Toolbar variant="dense">
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              component={Link}
              to="/"
            >
              <HomeIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Application Secrets
            </Typography>

            {IsAuthenticated ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginRight: "14rem", flexGrow: 1 }}>
                  <Tooltip title="Return to Argocd UI" arrow>
                    <Button
                      variant="outlined" color="primary"
                      endIcon={<img src={argocdlIcon} alt="argocd" style={{ width: 24, height: 24 }} />}
                      component={Link}
                      to="https://gitops.inkuda.com/applications"
                    >
                      <span style={{ color: 'white' }}>ArgoCD</span>
                    </Button>
                  </Tooltip>
                </div>
                <IconButton
                  size="large"
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
              </div>
            ) : null}
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={handleUserInfo}>User info</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
};

export default AppMenuBar;
